<template>
  <div class="content content-narrow plant-detail">
    <div class="col-12 gt-details">
      <div class="block">
        <div v-if="showLoader" class="overlay"></div>
        <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" :color="loaderColor" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div :class="`block-header ${bgColor}`">
          <h3 class="block-title text-white"><i class="fa fa-seedling text-white"></i> Plant Details</h3>
          <div class="blok-title text-white text-right">
            <a href="" @click.prevent="$router.go(-1)" data-toggle="tooltip" data-placement="left" title="Go back" class="js-tooltip-enabled text-white" data-original-title="Back">
              <i class="fa fa-angle-double-left text-white"></i> Back
            </a>
          </div>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.Id }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Label</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.Label }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">State</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.State }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Growth Phase</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3"><span :class="`badge ${badgeColor}`">{{ plant.GrowthPhase }}</span></div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Planted Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.PlantedDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Vegetative Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.VegetativeDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Flowering Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.FloweringDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvested Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.HarvestedDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Destroyed Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.DestroyedDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Destroyed Note</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.Label }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Destroyed By User Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.DestroyedByUserName) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Patient License Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.PatientLicenseNumber) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvest Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.HarvestId) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvested Unit Of Weight Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.HarvestedUnitOfWeightName) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvested Unit Of Weight Abbreviation</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.HarvestedUnitOfWeightAbbreviation) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvested Wet Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(plant.HarvestedWetWeight) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvest Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.HarvestCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is On Hold</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.IsOnHold }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Last Modified</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(plant.LastModified) }}</div>
          </div>
        </div>
        <div :class="`block-header ${bgColor}`">
          <h3 class="block-title text-white"><i class="fa fa-cannabis"></i> Assigned Strain</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Strain Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.StrainId }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Strain Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.StrainName }}</div>
          </div>
        </div>
        <div :class="`block-header ${bgColor}`">
          <h3 class="block-title text-white"><i class="fa fa-object-group"></i> Assigned Plant batch</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Batch Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.PlantBatchId }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Plant Batch Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.PlantBatchName }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Plant Batch Type</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.PlantBatchTypeName }}</div>
          </div>
        </div>
        <div :class="`block-header ${bgColor}`">
          <h3 class="block-title text-white"><i class="fa fa-door-open"></i> Assigned Room</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.RoomId }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ plant.RoomName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

export default {
  name: 'PlantDetails',
  data() {
    return {
      plant: {
        Id: 0,
        Label: null,
        State: null,
        GrowthPhase: null,
        PlantBatchId: null,
        PlantBatchName: null,
        PlantBatchTypeName: null,
        StrainId: null,
        StrainName: null,
        RoomId: null,
        RoomName: null,
        PatientLicenseNumber: null,
        HarvestId: null,
        HarvestedUnitOfWeightName: null,
        HarvestedUnitOfWeightAbbreviation: null,
        HarvestedWetWeight: null,
        HarvestCount: 0,
        IsOnHold: false,
        PlantedDate: null,
        VegetativeDate: null,
        FloweringDate: null,
        HarvestedDate: null,
        DestroyedDate: null,
        DestroyedNote: null,
        DestroyedByUserName: null,
        LastModified: null
      },
      showLoader: false,
      bgColor: 'bg-info',
      badgeColor: 'badge-info',
      loaderColor: '#5C7FD1'
    };
  },
  created() {
    let vm = this;
    if (vm.$router.currentRoute.path.includes('flowering')) {
      vm.bgColor = 'bg-success';
      vm.badgeColor = 'badge-success';
      vm.loaderColor = '#4EC37B';
    }
    vm.showLoader = true;
    helper.sendPostRequest('/plants/get', { id: vm.$route.params.id})
      .then((data) => {
        if (data.status === 'success') {
          vm.plant = data.data;
        } else {
          vm.$router.go(-1);
        }
        vm.showLoader = false;
      });
  },
  components: {
    HashLoader
  },
  methods: {
    getDate(dateText) {
      if (dateText === '') {
        return 'null';
      }
      let date = new Date(dateText).toISOString().substr(0, 19).replace('T', ' ');
      return date;
    },
    getValue(value) {
      if (!value) {
        return 'null';
      }
      return value;
    }
  }
};
</script>

<style>
.plant-detail .block-content {
  word-wrap: break-word;
}
.hidden-border {
  display: block;
}
.border-top {
  margin: 10px 0;
}
@media only screen and (min-width: 575px) {
  .hidden-border {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// source/components/PlantDetails.vue